import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#697077",
      d: "M6.026 11.966a.834.834 0 0 1 1.281 1.067l-2.083 2.5a.834.834 0 0 1-1.103.16l-1.25-.833a.834.834 0 0 1 .851-1.431l.073.044.626.418 1.605-1.925zm10.641 1.367a.833.833 0 0 1 0 1.666h-7.5a.833.833 0 0 1 0-1.666h7.5zM6.026 7.799c.295-.353.821-.401 1.174-.107s.401.821.107 1.174l-2.083 2.5a.833.833 0 0 1-1.103.159l-1.25-.833a.834.834 0 0 1 .851-1.431l.073.044.626.417 1.605-1.925zm10.641 1.367a.833.833 0 0 1 0 1.666h-7.5a.833.833 0 0 1 0-1.666h7.5zM6.026 3.633c.295-.353.821-.401 1.174-.107s.401.821.107 1.174L5.224 7.2a.834.834 0 0 1-1.103.16l-1.25-.833a.834.834 0 0 1 .851-1.431l.073.044.626.417 1.605-1.925zM16.667 5a.833.833 0 0 1 0 1.666h-7.5a.833.833 0 0 1 0-1.666h7.5z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "list-checklist"}) } }